import { adminDb } from "~/core/initFirebaseAdmin";
import type { NextPageContext } from "next";
import firestoreToJson from "~/core/firestoreToJson";
import { getFeaturedProjects } from "~/core/firebaseQueries";
import { DocumentData, FieldValue } from "firebase-admin/firestore";
export { default } from "~/components/SingleProject";
import { hasCookie, setCookie } from "cookies-next";

export async function getServerSideProps(context: NextPageContext) {
  const [q, featuredProjects] = await Promise.all([
    adminDb
      .collection("projects")
      .where("slug", "==", context.query.slug)
      .get(),
    getFeaturedProjects(),
  ]);

  if (q.empty) {
    return {
      notFound: true,
    };
  }

  const updateData: DocumentData = {
    viewCount: FieldValue.increment(1),
  };

  if (!hasCookie(q.docs[0].id, { req: context.req, res: context.res })) {
    updateData.uniqueViewCount = FieldValue.increment(1);
    setCookie(q.docs[0].id, true, { req: context.req, res: context.res });
  }

  adminDb
    .collection("projects")
    .doc(q.docs[0].id)
    .set(updateData, { merge: true })
    .catch((e) => console.error("error while updating view counts", e));

  return {
    props: {
      project: firestoreToJson(q.docs[0]),
      featuredProjects: featuredProjects.length
        ? featuredProjects.map(firestoreToJson)
        : [],
    },
  };
}
